import { AnalyticsService } from "@/services/analyticsService";
import { AuthService } from "@/services/authService";
import { getFromQueryString } from "@/utils/url";
import { openModal } from "@/wc/components";

const enum PurchaseState {
  Success = "success",
  Cancel = "cancel",
}

const enum QsKeys {
  Success = "purchase_successful",
  Cancelled = "purchase_cancelled",
}

export class PurchaseNotificationService {
  analyticsService: AnalyticsService | undefined;
  authService: AuthService;

  constructor() {
    this.authService = new AuthService();

    import("../analyticsService").then(({ AnalyticsService }) => {
      this.analyticsService = new AnalyticsService();
    });
  }

  public process() {
    const purchaseState = this.getPurchaseStateFromQS();

    if (purchaseState == null) {
      return;
    }

    switch (purchaseState) {
      case PurchaseState.Success:
        this.handlePurchaseSuccess();
        break;

      case PurchaseState.Cancel:
        // A cancel redirect should still show the paywall modal upon redirection
        openModal("paywall", {});
        this.analyticsService?.trackCheckoutCancelled();
        break;
    }
  }

  private handlePurchaseSuccess() {
    openModal("welcomeToPro", {});
    this.analyticsService?.trackCheckoutSuccess();
  }

  private getPurchaseStateFromQS(): PurchaseState | undefined {
    const purchaseSuccessful = getFromQueryString(QsKeys.Success, true);

    if (purchaseSuccessful === "true") {
      return PurchaseState.Success;
    }

    const purchaseCancelled = getFromQueryString(QsKeys.Cancelled, true);
    if (purchaseCancelled === "true") return PurchaseState.Cancel;

    return undefined;
  }
}
